import React from "react";

const MakeItConsciousSymbols = ({
  experienceRating,
  cuisineRating,
  storyRating,
  sustainabilityRating,
  diversityRating,
}) => {
  return (
    <>
      {cuisineRating && <p className="value-rating">Cuisine</p>}
      {experienceRating && <p className="value-rating">Experience</p>}
      {storyRating && <p className="value-rating">Story</p>}
      {sustainabilityRating && <p className="value-rating">Sustainability</p>}
      {diversityRating && <p className="value-rating">Diversity</p>}
    </>
  );
};

export default MakeItConsciousSymbols;
